// src/features/auth/authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  accessToken: localStorage.getItem('accessToken') || null, // Load from localStorage if available
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
      localStorage.setItem('accessToken', action.payload); // Save token to localStorage
    },
    clearAccessToken: (state) => {
      state.accessToken = null;
      localStorage.removeItem('accessToken'); // Remove token from localStorage
    },
  },
});

export const { setAccessToken, clearAccessToken } = authSlice.actions;
export const selectAccessToken = (state) => state.auth.accessToken;
export default authSlice.reducer;
